import React from 'react';
import PropTypes from 'prop-types';

const Address = ({id, street, streetNo, zip, city}) => (
<div className="customer-aux">
    {street} {streetNo}, {zip} {city} 
</div>
);

export default Address;